var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313840",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.496 24.988h19.229V5.76H8.496v19.23zm19.829 1.2H7.896a.599.599 0 0 1-.599-.6V5.16a.6.6 0 0 1 .599-.6h20.429a.6.6 0 0 1 .6.6v20.428a.6.6 0 0 1-.6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.724 22.31a.6.6 0 0 1-.6-.6V11.364a.6.6 0 0 1 1.2 0V21.71a.6.6 0 0 1-.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.153 13.342a.6.6 0 0 1-.424-.176l-.998-.997-.974.972a.598.598 0 1 1-.847-.848l1.397-1.397a.598.598 0 0 1 .848 0l1.422 1.422a.6.6 0 0 1-.424 1.024M22.067 22.31H11.723a.6.6 0 0 1 0-1.2h10.344a.6.6 0 1 1 0 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.672 23.758a.6.6 0 0 1-.424-1.024l.997-.998-.972-.973a.6.6 0 1 1 .847-.85l1.398 1.399a.6.6 0 0 1 0 .848l-1.422 1.422a.6.6 0 0 1-.424.176"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.8f05378090b644ed32c68a8449b80a02.svg";
export { ForwardRef as ReactComponent };